<template>
    <div class="notice">
        <div class="title">
            尊敬的用户: 很遗憾地通知您，本小程序将于近期正 式停止运营。
        </div>
        <div>对于给您带来的任何不便，我们深表歉意。</div>
        <div>如有任何疑问或需办理退款，请您添加 客服微信:chasi88进行联系。</div>
        <div>感谢您一直以来的支持与理解。</div>
        <div style="display: flex">
            <img
                class="img"
                style="height: 367.5px"
                src="../../assets/img/kefu2.jpg"
                alt="" />
            <img
                class="img"
                style="height: 367.5px"
                src="../../assets/img/kefu.jpg"
                alt="" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>

<style scoped lang="scss">
.notice {
    width: calc(100vw - 40px);

    margin-top: 100px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    font-size: 20px;

    .img {
        margin-top: 20px;
        width: 300px;
        // height: 200px;
    }
}
</style>
